export default __webpack_public_path__ + "static/media/maindswap-01.fc0214d3.jpg";